import { render, staticRenderFns } from "./DoctorNoteAdd.vue?vue&type=template&id=ed81d8b2&scoped=true&"
import script from "./DoctorNoteAdd.vue?vue&type=script&lang=js&"
export * from "./DoctorNoteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed81d8b2",
  null
  
)

export default component.exports